<template>
  <div id="app">
    <keep-alive><router-view /></keep-alive>
  </div>
</template>

<script>
import { removeToken, removeName, removeUserId, removeOrganId, removeRole } from '@/utils/auth'

export default {
  name: 'App',
  mounted() {
    // 检查是否是页面重新打开（不是刷新）
    if (!sessionStorage.getItem('pageLoaded')) {
      // 页面重新打开，清空token
      this.clearToken()
    }
    
    // 设置页面已加载标志
    sessionStorage.setItem('pageLoaded', 'true')
  },
  methods: {
    clearToken() {
      // 清空所有存储的信息
      removeToken()
      removeName()
      removeUserId()
      removeOrganId()
      removeRole()
    }
  }
}
</script>
<style>
html, body{
  margin: 0px;
  padding: 0px; 
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;    
  background: #fff; 
}
.mint-header{
  background-color: #1cc26f !important;
}
.loading{
  text-align: center;
}
.loading div{ 
  margin: 0 auto;
}
.content{
  margin-top: 40px;
}
.mint-button--primary{
  background-color: #1cc26f !important;
}
.mint-button--mini {
    display: inline-block !important;
    font-size: 12px !important;
    padding: 0 5px !important;
    height: 25px !important;
}
.no-list{
  text-align: center;
  margin-top: 60px;
  color: #707070;
}
.view-content{
  margin-top: 40px;
  background-color: #f5f5f5;
}
.mint-cell:last-child{
		background: #ffffff !important;
	}
  
.picker-items{
	width: 100% !important;
}
.ml10{
  margin-left: 10px;
}
.formState0{
  background: rgb(198, 226, 255);
	color: #409EFF;
}
.formState1{
  background: rgb(250, 236, 216);
	color: #E6A23C;
}
.formState2{
  background: rgb(225, 243, 216);
	color: #67C23A;
}
.formState3{
  background: rgb(253, 226, 226);
	color: #F56C6C;
}
.formState4{
  background: rgb(233, 233, 235);
	color: #909399;
} 
.view-item .mint-cell-wrapper{
	border: 1px solid #e9e9e9;
	margin-bottom: 10px;
	border-radius: 5px;
	background-image: linear-gradient(180deg, #fff, #fff 50%, transparent 50%);
}
.view-item .mint-radio-input:checked + .mint-radio-core,
.view-item .mint-checkbox-input:checked + .mint-checkbox-core{
    background-color: #1cc26f !important;
    border-color: #1cc26f !important;
}
.view-item .mint-navbar .mint-tab-item {
    padding: 10px 0;
}
.view-item .mint-tab-item-label {
    font-size: 16px !important; 
}
.view-item .mint-navbar .mint-tab-item.is-selected {
    border-bottom: 3px solid #1cc26f !important;
    color: #1cc26f !important; 
    margin-bottom: -3px;
}
.uni-flex{
  display: flex;
}
.mint-header.is-fixed { 
    z-index: 9999 !important;
}
</style>
